import { createSelector } from '@reduxjs/toolkit';
import { entitiesSelector } from "./base";
export const entriesSelector = createSelector(entitiesSelector, ({
  entries
}) => entries);